/**
 * ============================================================================
 *  statuts.ts — Vu, en cours, à suivre : UNE règle pour les puces et le compteur
 * ----------------------------------------------------------------------------
 *  Le menu des chapitres affiche, par chapitre, un statut ; son en-tête compte les
 *  chapitres vus. Les deux lisent ce fichier : un compteur et des puces qui
 *  calculeraient chacun de leur côté finiraient par se contredire.
 *
 *    statut = vu ? « Vu » : courant ? « En cours » : (premier non vu, non courant) ? « À suivre » : rien
 *
 *  Un chapitre courant déjà vu reste « Vu » (on le revoit) ; son contour et sa barre de
 *  progression le distinguent, pas son statut. Fonctions pures, éprouvées sous `node`.
 * ==========================================================================*/

export type Statut = "vu" | "en-cours" | "a-suivre" | "";

/** Les chapitres vus, parmi ceux du guide : une valeur périmée (chapitre retiré) ne compte pas. */
export function chapitresVus(ids: readonly string[], vus: readonly string[]): string[] {
  const ensemble = new Set(vus);
  return ids.filter((id) => ensemble.has(id));
}

/** Combien de chapitres sont vus : le chiffre de l'en-tête. */
export const compteurVus = (ids: readonly string[], vus: readonly string[]): number => chapitresVus(ids, vus).length;

/** Le « À suivre » : le premier chapitre qui n'est ni vu ni le courant, ou -1. */
export function indexASuivre(ids: readonly string[], vus: readonly string[], courant: number): number {
  const ensemble = new Set(vus);
  return ids.findIndex((id, index) => !ensemble.has(id) && index !== courant);
}

export function statutChapitre(
  index: number,
  ids: readonly string[],
  vus: readonly string[],
  courant: number,
): Statut {
  const id = ids[index];
  if (id === undefined) return "";
  if (vus.includes(id)) return "vu";
  if (index === courant) return "en-cours";
  return index === indexASuivre(ids, vus, courant) ? "a-suivre" : "";
}
